import { DEFAULT_LANGUAGE } from '@cibli/shared';
import ar_DZ from '@cibli/shared/locales/ar_DZ.json';
import ar_MA from '@cibli/shared/locales/ar_MA.json';
import de from '@cibli/shared/locales/de.json';
import en from '@cibli/shared/locales/en.json';
import es_MX from '@cibli/shared/locales/es_MX.json';
import es from '@cibli/shared/locales/es.json';
import fr from '@cibli/shared/locales/fr.json';
import pt from '@cibli/shared/locales/pt.json';
import ro from '@cibli/shared/locales/ro.json';
import tr from '@cibli/shared/locales/tr.json';
import uk from '@cibli/shared/locales/uk.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    'es-MX': { translation: es_MX },
    pt: { translation: pt },
    ro: { translation: ro },
    tr: { translation: tr },
    uk: { translation: uk },
    'ar-MA': { translation: ar_MA },
    'ar-DZ': { translation: ar_DZ },
  },
  lng: DEFAULT_LANGUAGE,
  // Resources are registered under the base code ('fr', 'uk', 'ar-MA' …), so the
  // fallback must use the base code too — 'fr-FR' resolves no bundle and every
  // missing key would leak as a raw key instead of falling back to French.
  fallbackLng: DEFAULT_LANGUAGE.split('-')[0],
  returnNull: false,
  returnEmptyString: false,
  keySeparator: '.',
  nsSeparator: ':',
  interpolation: {
    escapeValue: false,
  },
});
